export default __webpack_public_path__ + "static/media/portfolio-4.2d8bf5e6.jpg";